let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("253rR")).then(() => parcelRequire('4niNQ'));